/* global axios */
import ApiClient from './ApiClient';

class ContactConsentsAPI extends ApiClient {
  constructor() {
    super('contacts', { accountScoped: true });
  }

  list(contactId, params = {}) {
    return axios.get(`${this.url}/${contactId}/contact_consents`, { params });
  }

  create(contactId, payload) {
    return axios.post(`${this.url}/${contactId}/contact_consents`, payload);
  }

  update(contactId, consentId, payload) {
    return axios.patch(
      `${this.url}/${contactId}/contact_consents/${consentId}`,
      payload
    );
  }

  applyAll(contactId, payload) {
    return axios.post(`${this.url}/${contactId}/contact_consents/apply_all`, payload);
  }
}

export default new ContactConsentsAPI();
